export const APPLICATION_LOADING = 'APPLICATION_LOADING'
export const SET_PROPERTY = 'SET_PROPERTY'
export const SET_META = 'SET_META'

/**
 * CRUD mutations.
 */
export const SET_RESOURCE = 'SET_RESOURCE'
export const RESET_RESOURCE = 'RESET_RESOURCE'
export const SET_COLLECTION = 'SET_COLLECTION'
export const RESET_COLLECTION = 'RESET_COLLECTION'
export const ADD_COLLECTION = 'ADD_COLLECTION'

/**
 * User mutations
 */
export const SET_USER = 'SET_USER'
export const SET_USERS = 'SET_USERS'
export const ADD_USERS = 'ADD_USERS'
export const RESET_USER = 'RESET_USER'

/**
 * Agency mutations
 */
export const SET_AGENCY = 'SET_AGENCY'
export const SET_AGENCIES = 'SET_AGENCIES'
export const ADD_AGENCIES = 'ADD_AGENCIES'
export const RESET_AGENCY = 'RESET_AGENCY'
export const ADD_AGENCY_COORDINATOR = 'ADD_AGENCY_COORDINATOR'
export const REMOVE_AGENCY_COORDINATOR = 'REMOVE_AGENCY_COORDINATOR'

/**
 * Graduate mutations
 */
export const SET_GRADUATE = 'SET_GRADUATE'
export const SET_GRADUATES = 'SET_GRADUATES'
export const ADD_GRADUATES = 'ADD_GRADUATES'
export const ADD_GRADUATE = 'ADD_GRADUATE'
export const RESET_GRADUATE = 'RESET_GRADUATE'
export const ADD_DOCUMENT = 'ADD_DOCUMENT'
export const SET_GRADUATE_PLACEMENT = 'SET_GRADUATE_PLACEMENT'

/**
 * Assessments mutations
 */
export const SET_ASSESSMENTS = 'SET_ASSESSMENTS'

/**
 * Capabilities mutations
 */
export const SET_CAPABILITIES = 'SET_CAPABILITIES'
export const SET_RESULT = 'SET_RESULT'

/**
 * Manager mutations
 */
export const SET_MANAGER = 'SET_MANAGER'
export const SET_MANAGERS = 'SET_MANAGERS'
export const ADD_MANAGERS = 'ADD_MANAGERS'
export const ADD_MANAGER = 'ADD_MANAGER'

/**
 * Program mutations
 */
export const SET_PROGRAM = 'SET_PROGRAM'
export const SET_PROGRAMS = 'SET_PROGRAMS'
export const RESET_PROGRAM = 'RESET_PROGRAM'
export const RESET_PROGRAMS = 'RESET_PROGRAMS'

/**
 * Placement mutations
 */
export const SET_PLACEMENT = 'SET_PLACEMENT'
export const SET_PLACEMENTS = 'SET_PLACEMENTS'

/**
 * Performance/development objective mutations
 */
export const SET_OBJECTIVES = 'SET_OBJECTIVES'
export const ADD_OBJECTIVE = 'ADD_OBJECTIVE'
export const DELETE_OBJECTIVE = 'DELETE_OBJECTIVE'
export const ADD_MILESTONE = 'ADD_MILESTONE'
export const DELETE_MILESTONE = 'DELETE_MILESTONE'
export const ADD_ACTION = 'ADD_ACTION'
export const DELETE_ACTION = 'DELETE_ACTION'

/**
 * Task mutations
 */
export const SET_TASKS = 'SET_TASKS'

/**
 * Dashboard mutations
 */
export const SET_ACTIVE_PLACEMENTS = 'SET_ACTIVE_PLACEMENTS'
export const SET_GRADUATE_PLACEMENTS = 'SET_GRADUATE_PLACEMENTS'
export const SET_PLACEMENT_COMPLETION = 'SET_PLACEMENT_COMPLETION'
export const SET_PERFORMANCE_ASSESSMENTS = 'SET_PERFORMANCE_ASSESSMENTS'

/**
 * Logs
 */
export const SET_LOGS = 'SET_LOGS'
